import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
const ThankyouForm = () => {
  const [redirectTimer, setRedirectTimer] = useState(5);
  const navigate = useNavigate();
  const [publicReviewUrl, setPublicReviewUrl] = useState('');
  const location = useLocation();
  const { rating } = location.state || {};
  const [propertyName, setPropertyName] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [isBlinking, setIsBlinking] = useState(false);
  
  useEffect(() => {

    const publicReviewUrl = localStorage.getItem('publicReviewUrl');
    const propertyName = localStorage.getItem('propertyName');
    setPropertyName(propertyName);
    setPublicReviewUrl(publicReviewUrl);
    if (rating >= 4) {
        setAlertMessage('You can right-click and paste your comment in google review comment section.');
    }
 
    const timer = setInterval(() => {
      setRedirectTimer((prevTimer) => prevTimer - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsBlinking((prevState) => !prevState);
    }, 500);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (redirectTimer === 0) {
      redirectToSourceReview();
    }
  }, [redirectTimer]);

  const redirectToSourceReview = () => {
    if (rating >= 4) {
      window.location.href = publicReviewUrl;
    } else {
      navigate('/thank-you');
    }
  };

  const getTitleAndMessage = () => {
    let title = '';
    let message = '';

    if (rating > 3) {
      title = 'Thank You!';
      message = `Your feedback has been submitted. We are thrilled to hear you had a delightful experience at our hotel. Your kind words encourage us to continue offering exceptional service and comfort to all our guests.`;
    } else {
      title = 'Sorry!';
      message = `We appreciate your feedback and sincerely apologize for not meeting your expectations. Your insights are crucial for our improvement. We look forward to enhancing your next experience with us.`;
    }

    return { title, message, alertMessage };
  };

  const handleclickback = () =>{
      const propertyId = localStorage.getItem('propertyId');
      const bookingId = localStorage.getItem('bookingId');
      const guestFullName = localStorage.getItem('guestName');
      const bookingSource = localStorage.getItem('source');

    navigate(`/review?origin=QR&propertyId=${propertyId}&bookingId=${bookingId}&guestName=${guestFullName}&source=${bookingSource}`)
  } 

  const { title, message } = getTitleAndMessage();

  return (
    <div style={{ position: 'relative', height: '50vh'  }}>
      <h1 className="header-name">{propertyName}</h1>
      <div className="reviews-content reviews-content-thankyouform">
        <h2 className='title-heading'>{title}</h2>
        <label className="labelText">{message}</label>
        <div className="form">
            <button className="goback-button" onClick={handleclickback}>Go Back</button>
           {alertMessage && <p className={`alert-message ${isBlinking ? 'blinking' : ''}`}><span style={{fontSize:'small', color:'#3C78D8'}}>{alertMessage}</span></p>}
        </div>
      </div>
    </div>
  );
};


export default ThankyouForm;
